export default __webpack_public_path__ + "img/2aedc0dadd3fae3a9743c2f5fc969ef3.svg";